import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

// 云投屏软件专属页面
// 平台名称：G135
const DLNAPage: React.FC = () => {
  const [qrCodeUrl, setQrCodeUrl] = useState<string>('');
  const [currentScreenshot, setCurrentScreenshot] = useState(0);

  // 平台名称
  const platformName = 'G135';
  // APP名称
  const appName = '云投屏软件';
  // 上架名称
  const listingName = '云投屏软件';
  // 上架时间
  const listingDate = '2026/08/07 10:30';

  // 软件信息
  const appInfo = {
    size: '9.75 MB',
    downloads: '56次下载',
    version: 'v1.0.0.2268',
    requirements: 'Android 8.0以上',
    developer: '钟志华',
    updateTime: '2026/09/05 10:30',
  };

  // 标签
  const tags = ['常用工具', '视频播放', '投屏必备', '系统工具', '影音娱乐', '网络工具'];

  // 小编点评
  const editorReview = '无线投屏协作工具，支持手机、平板等设备快速投屏，实现多屏互动，让演示和分享更加便捷高效。';

  // 软件截图 - 使用参考代码中的图片
  const screenshots = [
    { id: 1, url: '/images/adv/10.jpg', label: '投屏首页' },
    { id: 2, url: '/images/adv/11.png', label: '设备连接' },
    { id: 3, url: '/images/adv/12.jpg', label: '媒体播放' },
  ];

  // 自动轮播截图
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentScreenshot((prev) => (prev + 1) % screenshots.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  // 生成二维码
  useEffect(() => {
    const generateQR = async () => {
      try {
        const dataUrl = await QRCode.toDataURL('https://g135.cn/app/dlna/lts/cscdlna_official_v1.0.0.2268_20260905_095638_lts.apk', {
          width: 280,
          margin: 2,
          color: {
            dark: '#1e293b',
            light: '#ffffff'
          }
        });
        setQrCodeUrl(dataUrl);
      } catch (error) {
        console.error('生成二维码失败:', error);
      }
    };
    generateQR();
  }, []);

  // 处理下载
  const handleDownload = () => {
    window.open('https://g135.cn/app/dlna/lts/cscdlna_official_v1.0.0.2268_20260905_095638_lts.apk', '_blank');
  };

  // 处理图片加载失败
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
    const placeholder = img.nextElementSibling as HTMLElement;
    if (placeholder) {
      placeholder.style.display = 'flex';
    }
  };

  return (
    <div className="dlna-page">
      {/* 主内容 */}
      <main className="dlna-main">
        <div className="dlna-main-content">
          {/* 左侧主内容 */}
          <div className="dlna-left">
            {/* 应用头部 */}
            <div className="dlna-app-header">
              <div className="dlna-app-icon-wrapper">
                <img 
                  src="/images/products/cloud-cast.png" 
                  alt="云投屏软件" 
                  className="dlna-app-icon-img"
                  onError={handleImageError}
                />
                <div className="dlna-app-icon-placeholder" style={{ display: 'none' }}>
                  <span>📺</span>
                </div>
              </div>
              <div className="dlna-app-info">
                <h1 className="dlna-app-name">{appName}</h1>
                <div className="dlna-app-meta">
                  <span className="dlna-meta-item">{appInfo.size}</span>
                  <span className="dlna-meta-divider">|</span>
                  <span className="dlna-meta-item">{appInfo.downloads}</span>
                </div>
                <div className="dlna-app-tags">
                  {tags.map((tag, index) => (
                    <span key={index} className="dlna-tag">{tag}</span>
                  ))}
                </div>
                <div className="dlna-app-description">
                  <p>{editorReview}</p>
                </div>
              </div>
            </div>

            {/* 软件截图 */}
            <div className="dlna-screenshots">
              <h3 className="dlna-section-title">{appName}最新版截图</h3>
              <div className="dlna-screenshot-carousel">
                <div className="dlna-screenshot-display">
                  <img 
                    src={screenshots[currentScreenshot].url} 
                    alt={screenshots[currentScreenshot].label}
                    className="dlna-screenshot-image"
                    onError={handleImageError}
                  />
                  <div className="dlna-screenshot-placeholder" style={{ display: 'none' }}>
                    <span className="dlna-screenshot-emoji">📱</span>
                    <span className="dlna-screenshot-label">{screenshots[currentScreenshot].label}</span>
                  </div>
                </div>
                <div className="dlna-screenshot-thumbnails">
                  {screenshots.map((s, index) => (
                    <div
                      key={s.id}
                      className={`dlna-thumbnail ${currentScreenshot === index ? 'active' : ''}`}
                      onClick={() => setCurrentScreenshot(index)}
                    >
                      <img src={s.url} alt={s.label} className="dlna-thumbnail-img" />
                      <span className="dlna-thumbnail-label">{s.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 详细信息 */}
            <div className="dlna-info-panel">
              <h3 className="dlna-section-title">详细信息</h3>
              <div className="dlna-info-grid">
                <div className="dlna-info-row">
                  <span className="dlna-info-label">版本</span>
                  <span className="dlna-info-value">{appInfo.version}</span>
                </div>
                <div className="dlna-info-row">
                  <span className="dlna-info-label">大小</span>
                  <span className="dlna-info-value">{appInfo.size}</span>
                </div>
                <div className="dlna-info-row">
                  <span className="dlna-info-label">更新</span>
                  <span className="dlna-info-value">{appInfo.updateTime}</span>
                </div>
                <div className="dlna-info-row">
                  <span className="dlna-info-label">要求</span>
                  <span className="dlna-info-value">{appInfo.requirements}</span>
                </div>
                <div className="dlna-info-row">
                  <span className="dlna-info-label">开发者</span>
                  <span className="dlna-info-value">{appInfo.developer}</span>
                </div>
                <div className="dlna-info-row">
                  <span className="dlna-info-label">上架名称</span>
                  <span className="dlna-info-value">{listingName}</span>
                </div>
                <div className="dlna-info-row">
                  <span className="dlna-info-label">上架时间</span>
                  <span className="dlna-info-value">{listingDate}</span>
                </div>
              </div>
            </div>
          </div>

          {/* 右侧下载卡片 */}
          <div className="dlna-right">
            <div className="dlna-download-card">
              <div className="dlna-download-header">
                <img 
                  src="/images/products/cloud-cast.png" 
                  alt="云投屏软件" 
                  className="dlna-download-icon-img"
                  onError={handleImageError}
                />
                <div className="dlna-download-icon-placeholder" style={{ display: 'none' }}>
                  <span>📺</span>
                </div>
                <h2 className="dlna-download-title">{appName}</h2>
              </div>

              <div className="dlna-download-info">
                <div className="dlna-download-info-item">
                  <span className="dlna-info-label-sm">大小</span>
                  <span className="dlna-info-value-sm">{appInfo.size}</span>
                </div>
                <div className="dlna-download-info-item">
                  <span className="dlna-info-label-sm">下载</span>
                  <span className="dlna-info-value-sm">{appInfo.downloads}</span>
                </div>
              </div>

              <div className="dlna-download-time">
                <span className="dlna-time-label">📅 更新：</span>
                <span className="dlna-time-value">{appInfo.updateTime}</span>
              </div>
               <div className="dlna-info-row">
                  <span className="dlna-info-label">开发者</span>
                  <span className="dlna-info-value">{appInfo.developer}</span>
                </div>

              <div className="dlna-qr-section">
                <div className="dlna-qr-wrapper">
                  {qrCodeUrl ? (
                    <img src={qrCodeUrl} alt="下载二维码" className="dlna-qr-image" />
                  ) : (
                    <div className="dlna-qr-placeholder">
                      <span>🔄</span>
                      <p>生成二维码...</p>
                    </div>
                  )}
                </div>
                <p className="dlna-qr-tip">扫码打开当前页下载</p>
              </div>

              <div className="dlna-download-buttons">
                <button className="dlna-btn dlna-btn-primary" onClick={handleDownload}>
                  <svg className="dlna-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                  官方版本下载
                </button>
               
              </div>

              <div className="dlna-download-tags">
                {tags.map((tag, index) => (
                  <span key={index} className="dlna-download-tag">#{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <style>{`
        /* ===== 全局样式 ===== */
        .dlna-page {
          background: #f5f8ff;
          color: #1e293b;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          min-height: 100vh;
        }

        /* ===== 主内容 ===== */
        .dlna-main {
          padding: 24px 5%;
        }

        .dlna-main-content {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 360px;
          gap: 32px;
        }

        /* ===== 左侧 ===== */
        .dlna-left {
          min-width: 0;
        }

        /* 应用头部 */
        .dlna-app-header {
          background: white;
          border-radius: 16px;
          padding: 28px 32px;
          display: flex;
          gap: 24px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          margin-bottom: 24px;
        }

        .dlna-app-icon-wrapper {
          flex-shrink: 0;
          width: 96px;
          height: 96px;
        }

        .dlna-app-icon-img {
          width: 96px;
          height: 96px;
          border-radius: 20px;
          object-fit: contain;
          background: white;
          box-shadow: 0 4px 16px rgba(59, 130, 246, 0.15);
          border: 1px solid #e8edf5;
        }

        .dlna-app-icon-placeholder {
          width: 96px;
          height: 96px;
          border-radius: 20px;
          background: linear-gradient(135deg, #3b82f6, #7c3aed);
          display: none;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          color: white;
          box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
        }

        .dlna-app-info {
          flex: 1;
        }

        .dlna-app-name {
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 12px;
          color: #1e293b;
        }

        .dlna-app-meta {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 12px;
        }

        .dlna-meta-item {
          font-size: 14px;
          color: #64748b;
        }

        .dlna-meta-divider {
          color: #d1d5db;
        }

        .dlna-app-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 16px;
        }

        .dlna-tag {
          padding: 4px 12px;
          background: #eef2ff;
          color: #4f46e5;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
        }

        .dlna-app-description p {
          font-size: 15px;
          line-height: 1.7;
          color: #475569;
          margin: 0;
        }

        /* 截图 */
        .dlna-screenshots {
          background: white;
          border-radius: 16px;
          padding: 24px 28px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          margin-bottom: 24px;
        }

        .dlna-section-title {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 16px;
          color: #1e293b;
        }

        .dlna-screenshot-carousel {
          display: flex;
          gap: 20px;
          align-items: flex-start;
        }

        .dlna-screenshot-display {
          flex: 1;
          min-height: 320px;
          background: #f8fafc;
          border-radius: 12px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .dlna-screenshot-image {
          width: 100%;
          height: 100%;
          max-height: 400px;
          object-fit: contain;
          border-radius: 12px;
          background: #f8fafc;
        }

        .dlna-screenshot-placeholder {
          background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
          border-radius: 12px;
          width: 100%;
          min-height: 320px;
          display: none;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }

        .dlna-screenshot-emoji {
          font-size: 64px;
        }

        .dlna-screenshot-label {
          font-size: 14px;
          color: #64748b;
          font-weight: 500;
        }

        .dlna-screenshot-thumbnails {
          display: flex;
          flex-direction: column;
          gap: 12px;
          flex-shrink: 0;
        }

        .dlna-thumbnail {
          width: 90px;
          cursor: pointer;
          border-radius: 8px;
          padding: 4px;
          border: 2px solid transparent;
          transition: all 0.3s;
          text-align: center;
          background: #f8fafc;
        }

        .dlna-thumbnail:hover {
          border-color: #d1d5db;
        }

        .dlna-thumbnail.active {
          border-color: #3b82f6;
          background: #eff6ff;
        }

        .dlna-thumbnail-img {
          width: 100%;
          height: 60px;
          object-fit: cover;
          border-radius: 6px;
          background: #e8edf5;
        }

        .dlna-thumbnail-label {
          font-size: 10px;
          color: #94a3b8;
          margin-top: 4px;
          display: block;
        }

        /* 信息面板 */
        .dlna-info-panel {
          background: white;
          border-radius: 16px;
          padding: 24px 28px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        }

        .dlna-info-grid {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .dlna-info-row {
          display: flex;
          padding: 8px 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .dlna-info-row:last-child {
          border-bottom: none;
        }

        .dlna-info-label {
          width: 100px;
          flex-shrink: 0;
          font-size: 14px;
          color: #94a3b8;
        }

        .dlna-info-value {
          font-size: 14px;
          color: #1e293b;
        }

        /* ===== 右侧下载卡片 ===== */
        .dlna-right {
          flex-shrink: 0;
        }

        .dlna-download-card {
          background: white;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          position: sticky;
          top: 100px;
        }

        .dlna-download-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          padding-bottom: 16px;
          border-bottom: 1px solid #f1f5f9;
        }

        .dlna-download-icon-img {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          object-fit: contain;
          background: white;
          border: 1px solid #e8edf5;
        }

        .dlna-download-icon-placeholder {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          background: linear-gradient(135deg, #3b82f6, #7c3aed);
          display: none;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: white;
        }

        .dlna-download-title {
          font-size: 18px;
          font-weight: 600;
          margin: 0;
          color: #1e293b;
        }

        .dlna-download-info {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px 16px;
          margin-bottom: 16px;
        }

        .dlna-download-info-item {
          display: flex;
          flex-direction: column;
        }

        .dlna-info-label-sm {
          font-size: 11px;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .dlna-info-value-sm {
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
        }

        .dlna-download-time {
          padding: 8px 12px;
          background: #f8fafc;
          border-radius: 8px;
          font-size: 13px;
          color: #64748b;
          margin-bottom: 16px;
        }

        .dlna-time-label {
          font-weight: 500;
        }

        .dlna-time-value {
          color: #1e293b;
        }

        .dlna-qr-section {
          text-align: center;
          padding: 12px 0 16px;
          border-top: 1px solid #f1f5f9;
          border-bottom: 1px solid #f1f5f9;
          margin-bottom: 16px;
        }

        .dlna-qr-wrapper {
          display: inline-block;
          background: white;
          padding: 8px;
          border-radius: 12px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
        }

        .dlna-qr-image {
          width: 120px;
          height: 120px;
          display: block;
        }

        .dlna-qr-placeholder {
          width: 120px;
          height: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #f8fafc;
          border-radius: 8px;
        }

        .dlna-qr-placeholder span {
          font-size: 32px;
        }

        .dlna-qr-placeholder p {
          font-size: 11px;
          color: #94a3b8;
          margin: 4px 0 0;
        }

        .dlna-qr-tip {
          font-size: 12px;
          color: #94a3b8;
          margin: 8px 0 0;
        }

        .dlna-download-buttons {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 16px;
        }

        .dlna-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
          width: 100%;
        }

        .dlna-btn-primary {
          background: linear-gradient(135deg, #3b82f6, #7c3aed);
          color: white;
          box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
        }

        .dlna-btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 24px rgba(59, 130, 246, 0.4);
        }

        .dlna-btn-secondary {
          background: #f1f5f9;
          color: #1e293b;
          border: 1px solid #e2e8f0;
        }

        .dlna-btn-secondary:hover {
          background: #e2e8f0;
        }

        .dlna-btn-icon {
          width: 18px;
          height: 18px;
        }

        .dlna-download-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          padding-top: 8px;
        }

        .dlna-download-tag {
          font-size: 11px;
          color: #94a3b8;
          background: #f8fafc;
          padding: 2px 10px;
          border-radius: 10px;
        }

        /* ===== 响应式 ===== */
        @media (max-width: 1024px) {
          .dlna-main-content {
            grid-template-columns: 1fr;
          }

          .dlna-right {
            order: -1;
          }

          .dlna-download-card {
            position: static;
          }

          .dlna-app-header {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .dlna-app-meta {
            justify-content: center;
          }

          .dlna-app-tags {
            justify-content: center;
          }

          .dlna-screenshot-carousel {
            flex-direction: column;
            align-items: center;
          }

          .dlna-screenshot-thumbnails {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
          }

          .dlna-thumbnail {
            width: 80px;
          }
        }

        @media (max-width: 640px) {
          .dlna-app-header {
            padding: 20px;
          }

          .dlna-app-name {
            font-size: 22px;
          }

          .dlna-app-icon-img,
          .dlna-app-icon-placeholder {
            width: 72px;
            height: 72px;
          }

          .dlna-app-icon-placeholder {
            font-size: 36px;
          }

          .dlna-download-info {
            grid-template-columns: 1fr 1fr;
          }

          .dlna-info-panel {
            padding: 16px 18px;
          }

          .dlna-info-label {
            width: 80px;
            font-size: 13px;
          }

          .dlna-info-value {
            font-size: 13px;
          }

          .dlna-download-card {
            padding: 16px;
          }

          .dlna-qr-image {
            width: 100px;
            height: 100px;
          }

          .dlna-qr-placeholder {
            width: 100px;
            height: 100px;
          }

          .dlna-screenshots {
            padding: 16px;
          }

          .dlna-thumbnail {
            width: 65px;
          }

          .dlna-thumbnail-img {
            height: 45px;
          }

          .dlna-download-icon-img,
          .dlna-download-icon-placeholder {
            width: 40px;
            height: 40px;
          }

          .dlna-download-icon-placeholder {
            font-size: 20px;
          }

          .dlna-download-title {
            font-size: 16px;
          }

          .dlna-screenshot-display {
            min-height: 200px;
          }

          .dlna-screenshot-image {
            max-height: 260px;
          }
        }
      `}</style>
    </div>
  );
};

export default DLNAPage;